import { render, staticRenderFns } from "./CreatorRequestsSummary.vue?vue&type=template&id=3c0c84e4&"
import script from "./CreatorRequestsSummary.vue?vue&type=script&lang=js&"
export * from "./CreatorRequestsSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports